module.exports = __webpack_public_path__ + "static/media/printer_shared.0a02efef.ico";